module.exports = __webpack_public_path__ + "img/gernzhifu.1b95a313.png";